import * as types from '@/store/mutationTypes';
import childrenService from '@/http/services/childrenService';

export const actions = {
    registrationChild: async ({ dispatch }, payload) => {
        await childrenService.registrationChild(payload);

        dispatch('createNotification', { message: 'Child has been added' });
    },

    getChildren: async ({ commit }, payload) => {
        const children = await childrenService.getChildren(payload);

        commit(types.SET_CHILDREN, children);
    },

    getChildInfo: async ({ commit }, payload) => {
        const childInfo = await childrenService.getChildInfo(payload);

        commit(types.SET_CHILD_INFO, childInfo);
    },

    getChildScheduleInfo: async ({ commit }, payload) => {
        const childScheduleInfo = await childrenService.getChildScheduleInfo(payload);

        commit(types.SET_CHILD_SCHEDULE_INFO, childScheduleInfo);
    },

    deleteChild: async ({ dispatch }, payload) => {
        await childrenService.deleteChild(payload);

        dispatch('createNotification', { message: 'Child has been delete' });
        dispatch('getChildren', payload.parentId);
    },

    getChildInfoForEdit: async ({ commit, dispatch }, payload) => {
        const childInfoForEdit = await childrenService.getChildInfo(payload);

        commit(types.SET_CHILD_INFO_FOR_EDIT, childInfoForEdit);
        dispatch('getChildPhoto', payload.childId)
    },

    getChildPhoto: async ({ commit }, payload) => {
        const childPhoto = await childrenService.getChildPhoto(payload);

        commit(types.SET_CHILD_PHOTO, childPhoto);
    },

    changeChildPhoto: async ({ commit, dispatch }, payload) => {
        const childPhoto = await childrenService.changeChildPhoto(payload);

        commit(types.SET_CHILD_PHOTO, childPhoto.data);
        dispatch('createNotification', { message: `You have successfully changed child photo` });
    },

    removeChildPhoto: async ({ commit, dispatch }, payload) => {
        await childrenService.removeChildPhoto(payload);

        commit(types.SET_CHILD_PHOTO, null);
        dispatch('createNotification', { message: `You have successfully remove child photo` });
    },

    editChildInfo: async ({ dispatch }, payload) => {
        const { parentId, childId} = payload;

        await childrenService.editChildInfo(payload);

        dispatch('createNotification', { message: 'Child information has been update' });
        dispatch('getChildInfoForEdit', { parentId, childId});
    },
};


// WEBPACK FOOTER //
// ./src/store/modules/children/actions.js